import { render, staticRenderFns } from "./CardPayroll.vue?vue&type=template&id=0abe0a38&"
import script from "./CardPayroll.vue?vue&type=script&lang=js&"
export * from "./CardPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports